import React from "react";
import SVG from "react-inlinesvg";
import { CartReferenceNumber } from "tsi-common-react/src/apps/checkout/CartReferenceNumber";
import { t } from "ttag";

import { templates } from "@reactivated";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import logo from "../assets/svg/logo.svg";

export const Template = (
    props: templates.CheckoutHeaderTemplate,
): React.ReactNode => {
    const secureCheckout = richT(t`<secure>secure</secure> checkout`, {
        secure: (children) => (
            <span className="checkout-header__header--bold">{children}</span>
        ),
    });
    return (
        <header className="checkout-header">
            <a className="logo-link" href={props.root_page_url}>
                <SVG
                    className="logo header-svg"
                    src={logo}
                    title={t`Stearns & Foster Logo`}
                />
            </a>

            <h1 className="checkout-header__header">{secureCheckout}</h1>

            <div className="checkout-header__header-cart-ref">
                <CartReferenceNumber
                    encodedBasketID={props.encoded_basket_id}
                    phoneNumber={props.support_website_phone_number}
                />
            </div>
        </header>
    );
};
